<div class="row">
  <div class="col-12 d-flex align-items-baseline">
    <div class="flex-grow-1">
      <h3 class="page-title">{{ title }}</h3>
    </div>
    <div class="flex-grow-0 text-end">
      <ng-content select="[buttons]"></ng-content>
    </div>
  </div>
  <div class="col-12">
    <ng-content select="[filters]"></ng-content>
  </div>
</div>
